import { findLinksBySignalID } from './findLinksBySignalID';
export function setPathLength(correlations, signalID, pathLength) {
    const links = findLinksBySignalID(correlations, signalID);
    links.forEach((link) => {
        var _a;
        const signal = link.signal;
        if (pathLength) {
            if (!signal.j) {
                signal.j = { pathLength };
            }
            else {
                signal.j.pathLength = pathLength;
            }
        }
        else {
            (_a = signal.j) === null || _a === void 0 ? true : delete _a.pathLength;
        }
    });
    return correlations;
}
//# sourceMappingURL=setPathLength.js.map